import { useSelector } from "react-redux";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import React, { useState } from "react";
import { DeleteOutline } from "@mui/icons-material";
import { Grid, Button, MenuItem, IconButton, Tooltip } from "@mui/material";

import "../../../css components/style.css";
import { TextField, Label } from "../../../../components";

export default function TemplateCallToActionButton({ formikProps, addSample }) {
  const [isInvalidPhone, setIsInvalidPhone] = useState(false); // clearer naming

  const { siteColors } = useSelector((state) => state.renderUIDetails);

  const emptyButton = {
    button_type: "",
    text: "",
    payload: "",
    url_type: "",
  };

  const handleChangePhoneNumber = (value, country, e, index) => {
    const onlyNumbers = value.replace(/\D/g, ""); // remove +, spaces, dashes

    // remove country code part
    const withoutCountryCode = onlyNumbers.startsWith(country.dialCode)
      ? onlyNumbers.slice(country.dialCode.length)
      : onlyNumbers;

    let invalid = false;

    // Validation rules
    if (country.dialCode === "91") {
      // India → must be exactly 10 digits
      if (withoutCountryCode.length > 0 && withoutCountryCode.length !== 10) {
        invalid = true;
      }
    } else if (country.dialCode === "62") {
      // Indonesia → must be 11–12 digits
      if (
        withoutCountryCode.length > 0 &&
        (withoutCountryCode.length < 11 || withoutCountryCode.length > 12)
      ) {
        invalid = true;
      }
    } else {
      // fallback for other countries → at least 6 digits
      if (withoutCountryCode.length > 0 && withoutCountryCode.length < 6) {
        invalid = true;
      }
    }

    setIsInvalidPhone(invalid);

    // update formik values
    const newButtons = [...formikProps.values.templateButtons.buttons];
    if (
      e?.target?.className === "country" ||
      e?.target?.className === "country-name"
    ) {
      newButtons[index].payload = "+" + country.dialCode;
    } else {
      newButtons[index].payload = value;
    }

    formikProps.setValues((prevVal) => ({
      ...prevVal,
      templateButtons: {
        ...prevVal.templateButtons,
        buttons: newButtons,
      },
    }));
  };

  const handleChangeType = (event, index) => {
    const urlType = event.target.value;
    const newButtons = [...formikProps.values.templateButtons.buttons];

    if (urlType === "static") {
      newButtons[index].url_type = urlType;
      newButtons[index].payload = "";
    } else if (urlType === "dynamic") {
      newButtons[index].url_type = urlType;
    }

    formikProps.setValues((prevVal) => ({
      ...prevVal,
      templateButtons: {
        ...prevVal.templateButtons,
        buttons: newButtons,
        count_of_variable:
          urlType === "dynamic" ? 1 : prevVal.templateButtons.count_of_variable,
      },
    }));
  };

  const handleRemoveButtons = (index) => {
    const newButtons = [...formikProps.values.templateButtons.buttons];
    newButtons.splice(index, 1);
    formikProps.setValues((prevVal) => ({
      ...prevVal,
      templateButtons: {
        ...prevVal.templateButtons,
        buttons: newButtons,
      },
    }));
  };

  const addButton = () => {
    const newButtons = [
      ...(formikProps.values.templateButtons.buttons || []),
      emptyButton,
    ];
    formikProps.setValues((prevVal) => ({
      ...prevVal,
      templateButtons: {
        ...prevVal.templateButtons,
        buttons: newButtons,
      },
    }));
  };

  return (
    <Grid container spacing={2}>
      {formikProps.values?.templateButtons?.buttons?.map((button, index) => (
        <React.Fragment key={index}>
          <Grid item xs={3}>
            <Label title="Button Type" />
            <TextField
              select
              placeholder="Button Type"
              name={`templateButtons.buttons[${index}].button_type`}
              formikProps={formikProps}
              disabled={
                Boolean(formikProps.values.ID) ||
                Boolean(addSample) ||
                formikProps.isSubmitting
              }
              SelectProps={{
                displayEmpty: true, // important to show the first empty value
              }}
              sx={{
                "& .MuiSelect-select": {
                  color: formikProps.values.category ? "inherit" : "#a2a2a2", // placeholder color
                },
              }}
            >
              <MenuItem value="" disabled>
                Select Button Type
              </MenuItem>
              <MenuItem
                value="phone_number"
                disabled={formikProps.values?.templateButtons?.buttons?.some(
                  (btn) => btn.button_type === "phone_number"
                )}
              >
                Phone Number
              </MenuItem>
              <MenuItem
                value="url"
                disabled={formikProps.values?.templateButtons?.buttons?.some(
                  (btn) => btn.button_type === "url"
                )}
              >
                Website
              </MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={3}>
            <Label title="Button Text" />
            <TextField
              name={`templateButtons.buttons[${index}].text`}
              placeholder="Button Text"
              formikProps={formikProps}
              disabled={
                Boolean(formikProps.values.ID) ||
                Boolean(addSample) ||
                formikProps.isSubmitting
              }
            />
          </Grid>

          {button.button_type === "url" && (
            <Grid item xs={2}>
              <Label title="URL Type" />
              <TextField
                select
                placeholder="URL Type"
                name={`templateButtons.buttons[${index}].url_type`}
                formikProps={formikProps}
                onChange={(event) => handleChangeType(event, index)}
                disabled={
                  Boolean(formikProps.values.ID) ||
                  Boolean(addSample) ||
                  formikProps.isSubmitting
                }
                SelectProps={{
                  displayEmpty: true, // important to show the first empty value
                }}
                sx={{
                  "& .MuiSelect-select": {
                    color: formikProps.values.category ? "inherit" : "#a2a2a2", // placeholder color
                  },
                }}
              >
                <MenuItem value="" disabled>
                  Select URL Type
                </MenuItem>
                <MenuItem value="static">Static</MenuItem>
                {/* <MenuItem value="dynamic">Dynamic</MenuItem> */}
              </TextField>
            </Grid>
          )}

          {button.button_type === "phone_number" && (
            <Grid item xs={5}>
              <Label title="Phone Number" />
              <PhoneInput
                value={
                  formikProps.values.templateButtons?.buttons[index]?.payload
                }
                onChange={(value, country, e) =>
                  handleChangePhoneNumber(value, country, e, index)
                }
                disabled={
                  Boolean(formikProps.values.ID) ||
                  Boolean(addSample) ||
                  formikProps.isSubmitting
                }
                inputProps={{ name: "mobileNumber" }}
                onBlur={formikProps.handleBlur}
                inputStyle={{
                  width: "100%",
                  fontSize: "12px",
                  color:
                    Boolean(formikProps.values.ID) ||
                    Boolean(addSample) ||
                    formikProps.isSubmitting
                      ? "rgba(0,0,0,0.38)"
                      : "currentColor",
                  borderColor: isInvalidPhone ? siteColors?.primary : "#949494",
                  padding: "10.5px 14px 12.5px 58px",
                  cursor: "default",
                  borderRadius: "12px",
                }}
              />
              {isInvalidPhone && (
                <span className="validationError">
                  {button?.payload?.startsWith("+91")
                    ? "Enter a valid 10 digit Indian number"
                    : button?.payload?.startsWith("+62")
                    ? "Enter a valid 11–12 digit Indonesian number"
                    : "Enter a valid phone number"}
                </span>
              )}
            </Grid>
          )}

          {button.url_type && (
            <Grid item xs={3}>
              <Label title="URL" />
              <TextField
                placeholder="URL"
                name={`templateButtons.buttons[${index}].payload`}
                formikProps={formikProps}
                disabled={
                  Boolean(formikProps.values.ID) ||
                  Boolean(addSample) ||
                  formikProps.isSubmitting
                }
              />
            </Grid>
          )}

          {!Boolean(formikProps.values.ID) && (
            <Grid textAlign="end" item xs={1}>
              <Tooltip title="Delete button">
                <IconButton
                  disabled={
                    Boolean(formikProps.values.ID) ||
                    Boolean(addSample) ||
                    formikProps.isSubmitting
                  }
                  onClick={() => handleRemoveButtons(index)}
                  style={{
                    color:
                      Boolean(formikProps.values.ID) ||
                      Boolean(addSample) ||
                      formikProps.isSubmitting
                        ? "rgba(0,0,0,0.38)"
                        : "#ff0000",
                  }}
                >
                  <DeleteOutline />
                </IconButton>
              </Tooltip>
            </Grid>
          )}
        </React.Fragment>
      ))}

      {Boolean(formikProps.values?.templateButtons?.type) &&
        !Boolean(formikProps.values.ID) &&
        (formikProps.values.templateButtons?.buttons?.length || 0) <= 1 && (
          <Grid item xs={12} textAlign="end">
            <Button
              disabled={
                Boolean(formikProps.values.ID) ||
                Boolean(addSample) ||
                formikProps.isSubmitting
              }
              variant="contained"
              size="small"
              onClick={addButton}
            >
              Add Buttons
            </Button>
          </Grid>
        )}
    </Grid>
  );
}
